import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'

export default function SkeletonApps(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '40px 5px 108px',
    },
    card: {
      position: 'relative',
      marginBottom: 10,
      borderRadius: 10,
      boxShadow: 'none',
      textTransform: 'capitalize',
      marginTop: 10,
      height: 146,
      minWidth: 189,
      width: '100%',
      color: colors.accentColor,
      fontSize: theme.typography.pxToRem(18),
      backgroundColor: colors.colorBackgroundSecundary,
      '&:hover': {
        boxShadow: '0px 12px 42px -4px rgba(24, 39, 75, 0.12)',
        backgroundColor: colors.colorBackground,
      },
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: colors.textBody,
      fontSize: theme.typography.pxToRem(36),
      left: 8,
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        marginBottom: 9,
        '&::after': {
          bottom: 4,
        },
      },
    },
    textSubTitle: {
      position: 'relative',
      fontFamily: 'Roboto',
      padding: '10px 0px',
      fontSize: theme.typography.pxToRem(18),
      color: colors.textBody,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: 400,
      opacity: 0.5,
    },
    button: {
      border: `1px solid ${colors.textAccentColor}`,
      minWidth: 0,
      marginBottom: 10,
      padding: '8px 35px',
      borderRadius: 5,
      '&:hover': {
        background: colors.colorBackgroundSecundary,
        color: colors.accentColor,
      },
    },
    icon: {
      width: 24,
      height: 24,
    },
    box: {
      display: 'flex',
      marginBottom: '50px',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
    textList: {
      marginRight: 8,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      marginLeft: 8,
      textTransform: 'uppercase',
      color: colors.accentColor,
      '&:hover': {
        color: colors.textAccentColor,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    buttonMore: {
      maxWidth: 360,
      width: '100%',
      marginTop: 80,
      height: 42,
      borderRadius: 25,
      backgroundColor: colors.colorWithoutGradient,
      alignSelf: 'center',
      color: colors.accentColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      marginRight: 8,
      marginLeft: 8,
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: colors.colorWithoutGradient,
      },
    },
  }))
  const classes = useStyles()

  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Apps do governo
          </Typography>
          <Typography className={classes.textSubTitle}>
            Baixe nossos apps
          </Typography>
        </Box>
        <Box>
          {Array.from({ length: 5 }).map((_, index) => (
            <Card key={index} className={classes.card}>
              <Box
                position="absolute"
                height="100%"
                width="100%"
                flexDirection="column"
                alignItems="center"
                justifyContent="space-around"
                zIndex="1"
                style={{
                  background: colors.cardAccentColor,
                  backgroundSize: 'cover',
                }}
              >
                <Skeleton width="100%" height="100%" />
              </Box>
            </Card>
          ))}
        </Box>
        <a href="/aplicativos" className={classes.buttonMore} rel="noreferrer">
          <p className={classes.textList}>VEJA TODOS OS APLICATIVOS</p>
        </a>
      </Box>
    </Box>
  )
}
